import React from 'react';
import ReactDOM from 'react-dom';
import {Link} from "react-router-dom";
import './PrivacyPolicy.css';
import { useEffect } from "react";

function PrivacyPolicy() {
    useEffect(() => {
      setTimeout(() => window.scrollTo(0,0));
    });

    return (
      <div class="PrivacyPolicy">
        <>
  <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
  <title>Privacy Policy - Parlaye</title>
  <meta name="author" content="Liam Ross" />
  <style
    type="text/css"
    dangerouslySetInnerHTML={{
      __html:
        ' * {margin:0; padding:0; text-indent:0; }\n h1 { color: black; font-family:"Times New Roman", serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 14pt; }\n .s1 { color: black; font-family:"Times New Roman", serif; font-style: normal; font-weight: bold; text-decoration: underline; font-size: 12pt; }\n .p, p { color: black; font-family:"Times New Roman", serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 12pt; margin:0pt; }\n h2 { color: black; font-family:"Times New Roman", serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 12pt; }\n .a, a { color: #00F; font-family:"Times New Roman", serif; font-style: normal; font-weight: normal; text-decoration: underline; font-size: 12pt; }\n .s3 { color: #00F; font-family:"Times New Roman", serif; font-style: normal; font-weight: normal; text-decoration: underline; font-size: 12pt; }\n .s4 { color: black; font-family:"Times New Roman", serif; font-style: italic; font-weight: normal; text-decoration: none; font-size: 12pt; }\n .s5 { color: black; font-family:"Times New Roman", serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 12pt; }\n .s7 { color: #00F; font-family:"Times New Roman", serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 11pt; }\n .s8 { color: black; font-family:"Times New Roman", serif; font-style: normal; font-weight: normal; text-decoration: underline; font-size: 12pt; }\n .s9 { color: black; font-family:"Times New Roman", serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 12pt; }\n li {display: block; }\n #l1 {padding-left: 0pt;counter-reset: c1 1; }\n #l1> li>*:first-child:before {counter-increment: c1; content: counter(c1, lower-latin)") "; color: black; font-family:"Times New Roman", serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 12pt; }\n #l1> li:first-child>*:first-child:before {counter-increment: c1 0;  }\n li {display: block; }\n #l2 {padding-left: 0pt;counter-reset: d1 1; }\n #l2> li>*:first-child:before {counter-increment: d1; content: counter(d1, lower-latin)") "; color: black; font-family:"Times New Roman", serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 12pt; }\n #l2> li:first-child>*:first-child:before {counter-increment: d1 0;  }\n li {display: block; }\n #l3 {padding-left: 0pt;counter-reset: e1 1; }\n #l3> li>*:first-child:before {counter-increment: e1; content: counter(e1, lower-latin)") "; color: black; font-family:"Times New Roman", serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 12pt; }\n #l3> li:first-child>*:first-child:before {counter-increment: e1 0;  }\n li {display: block; }\n #l4 {padding-left: 0pt;counter-reset: f1 1; }\n #l4> li>*:first-child:before {counter-increment: f1; content: counter(f1, lower-latin)") "; color: black; font-family:"Times New Roman", serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 12pt; }\n #l4> li:first-child>*:first-child:before {counter-increment: f1 0;  }\n li {display: block; }\n #l5 {padding-left: 0pt;counter-reset: g1 1; }\n #l5> li>*:first-child:before {counter-increment: g1; content: counter(g1, lower-latin)") "; color: black; font-family:"Times New Roman", serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 12pt; }\n #l5> li:first-child>*:first-child:before {counter-increment: g1 0;  }\n li {display: block; }\n #l6 {padding-left: 0pt;counter-reset: h1 1; }\n #l6> li>*:first-child:before {counter-increment: h1; content: counter(h1, lower-latin)") "; color: black; font-family:"Times New Roman", serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 12pt; }\n #l6> li:first-child>*:first-child:before {counter-increment: h1 0;  }\n li {display: block; }\n #l7 {padding-left: 0pt;counter-reset: i1 1; }\n #l7> li>*:first-child:before {counter-increment: i1; content: counter(i1, lower-latin)") "; color: black; font-family:"Times New Roman", serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 12pt; }\n #l7> li:first-child>*:first-child:before {counter-increment: i1 0;  }\n li {display: block; }\n #l8 {padding-left: 0pt;counter-reset: j1 1; }\n #l8> li>*:first-child:before {counter-increment: j1; content: counter(j1, lower-latin)") "; color: black; font-family:"Times New Roman", serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 12pt; }\n #l8> li:first-child>*:first-child:before {counter-increment: j1 0;  }\n li {display: block; }\n #l9 {padding-left: 0pt;counter-reset: k1 1; }\n #l9> li>*:first-child:before {counter-increment: k1; content: counter(k1, lower-latin)") "; color: black; font-family:"Times New Roman", serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 12pt; }\n #l9> li:first-child>*:first-child:before {counter-increment: k1 0;  }\n li {display: block; }\n #l10 {padding-left: 0pt;counter-reset: l1 1; }\n #l10> li>*:first-child:before {counter-increment: l1; content: counter(l1, lower-latin)") "; color: black; font-family:"Times New Roman", serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 12pt; }\n #l10> li:first-child>*:first-child:before {counter-increment: l1 0;  }\n li {display: block; }\n #l11 {padding-left: 0pt; }\n #l11> li>*:first-child:before {content: "● "; color: black; font-family:"Times New Roman", serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 12pt; }\n li {display: block; }\n #l12 {padding-left: 0pt; }\n #l12> li>*:first-child:before {content: "● "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 12pt; }\n #l13 {padding-left: 0pt; }\n #l13> li>*:first-child:before {content: "● "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 12pt; }\n li {display: block; }\n #l14 {padding-left: 0pt; }\n #l14> li>*:first-child:before {content: "● "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 12pt; }\n #l15 {padding-left: 0pt; }\n #l15> li>*:first-child:before {content: "● "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 12pt; }\n li {display: block; }\n #l16 {padding-left: 0pt;counter-reset: p1 1; }\n #l16> li>*:first-child:before {counter-increment: p1; content: counter(p1, decimal)". "; color: black; font-family:"Times New Roman", serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 12pt; }\n #l16> li:first-child>*:first-child:before {counter-increment: p1 0;  }\n li {display: block; }\n #l17 {padding-left: 0pt; }\n #l17> li>*:first-child:before {content: "● "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 12pt; }\n #l18 {padding-left: 0pt; }\n #l18> li>*:first-child:before {content: "● "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 12pt; }\n table, tbody {vertical-align: top; overflow: visible; }\n'
    }}
  />
  <h1
    style={{
      paddingTop: "3pt",
      paddingLeft: "161pt",
      textIndent: "0pt",
      lineHeight: "162%",
      textAlign: "center"
    }}
  >
    PRIVACY POLICY PARLAYE
  </h1>
  <h1
    style={{
      paddingLeft: "161pt",
      textIndent: "0pt",
      lineHeight: "16pt",
      textAlign: "center"
    }}
  >
    Last updated: July 31, 2023
  </h1>
  <p
    className="s1"
    style={{
      paddingTop: "10pt",
      paddingLeft: "161pt",
      textIndent: "0pt",
      textAlign: "center"
    }}
  >
    INTRODUCTION
  </p>
  <p
    style={{
      paddingTop: "9pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    Parlaye, Inc. carrying on business as Parlaye (“<b>Parlaye</b>,” “<b>we</b>
    ,” “<b>us</b>,” “<b>our</b>”) respects your privacy and is committed to
    protecting it by providing and complying with this Privacy Policy.
  </p>
  <p
    style={{
      paddingTop: "9pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    Throughout this Privacy Policy, “<b>Personal Information</b>” means
    information that we can reasonably use to directly or indirectly identify
    you, such as your name, date of birth, country of origin, mailing address,
    e-mail address, telephone number, Internet protocol (IP) address used to
    connect your computer to the Internet, user name or other similar
    identifier, your age or other identifying information, and any other
    identifier we may use to contact you.
  </p>
  <p
    style={{
      paddingTop: "6pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    This Privacy Policy describes:
  </p>
  <ol id="l1">
    <li data-list-text="a)">
      <p
        style={{
          paddingTop: "9pt",
          paddingLeft: "47pt",
          textIndent: "-18pt",
          textAlign: "justify"
        }}
      >
        How we collect, use, disclose, and protect the Personal Information of
        our customers and users (“<b>you</b>”).
      </p>
    </li>
    <li data-list-text="b)">
      <p
        style={{
          paddingLeft: "47pt",
          textIndent: "-18pt",
          textAlign: "justify"
        }}
      >
        <a href="http://www.parlaye.com/" className="s5" target="_blank">
          The types of Personal Information we may collect from you or that you
          may provide when you visit our product page at{" "}
        </a>
        <span className="s3">www.parlaye.com</span> and register for, download
        and install the Parlaye App (collectively the “<b>App</b>”).
      </p>
    </li>
    <li data-list-text="c)">
      <p
        style={{
          paddingLeft: "47pt",
          textIndent: "-18pt",
          textAlign: "justify"
        }}
      >
        Our practices for collecting, using, maintaining, protecting, and
        disclosing that Personal Information.
      </p>
    </li>
  </ol>
  <p
    style={{
      paddingTop: "5pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    Please read this Privacy Policy carefully to understand our policies and
    practices for collecting, processing, and storing your Personal Information.
    If you do not agree with our policies and practices, your choice is not to
    use our App. By accessing or using our App, you indicate that you
    understand, accept, and consent to the practices described in this Privacy
    Policy. This Privacy Policy may change from time to time (see{" "}
    <span className="s3">Changes to Our Privacy Policy</span>).
  </p>
  <p
    style={{
      paddingTop: "9pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    Your continued use of our App after we make changes indicates that you
    accept and consent to those changes, so please check the Privacy Policy
    periodically for updates. We will notify you in advance of any material
    changes to this Privacy Policy and obtain your consent to any new ways that
    we collect, use, and disclose your Personal Information.
  </p>
  <p
    style={{
      paddingTop: "9pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    We will only use your Personal Information in accordance with this Privacy
    Policy unless otherwise required by Applicable Law (defined below). We take
    steps to ensure that the Personal Information that we collect about you is
    adequate, relevant, not excessive, and used for limited purposes.
  </p>
  <p
    style={{
      paddingTop: "10pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    This Privacy Policy is designed to provide transparency regarding Parlaye’s
    privacy policies with respect to your Personal Information we collect from
    you when you use our App, in accordance with the rules and protections
    around such information under Applicable Law.
  </p>
  <p
    style={{
      paddingTop: "9pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    This Privacy Policy applies to Personal Information we collect, use, or
    disclose about you:
  </p>
  <ol id="l2">
    <li data-list-text="a)">
      <p
        style={{
          paddingTop: "9pt",
          paddingLeft: "47pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        on our App;
      </p>
    </li>
    <li data-list-text="b)">
      <p
        style={{
          paddingTop: "3pt",
          paddingLeft: "47pt",
          textIndent: "-18pt",
          lineHeight: "14pt",
          textAlign: "left"
        }}
      >
        in email, text, and other electronic messages between you and us;
      </p>
    </li>
    <li data-list-text="c)">
      <p
        style={{ paddingLeft: "47pt", textIndent: "-18pt", textAlign: "left" }}
      >
        through links to third-party websites, plug-ins, services, social
        networks, or applications. Clicking on those links or enabling those
        connections may allow the third party to collect or share data about
        you. If you follow a link to a third-party website or engage a
        third-party plugin, please note that these third parties have their own
        privacy policies and we do not accept any responsibility or liability
        for these policies. We do not control these third-party websites, and we
        encourage you to read the privacy policy of every website you visit.
      </p>
    </li>
  </ol>
  <p
    style={{
      paddingTop: "6pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    This Privacy Policy DOES NOT apply to Personal Information that:
  </p>
  <ol id="l3">
    <li data-list-text="a)">
      <p
        style={{
          paddingTop: "9pt",
          paddingLeft: "47pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        we collect offline or through any other means, including on any other
        Parlaye or third-party website or mobile application (including our
        affiliates and subsidiaries); or
      </p>
    </li>
    <li data-list-text="b)">
      <p
        style={{ paddingLeft: "47pt", textIndent: "-18pt", textAlign: "left" }}
      >
        you provide to or that is collected by any third party (including our
        affiliates and subsidiaries), through any application or content
        (including advertising) that may link to or be accessible from or on our
        App.
      </p>
    </li>
  </ol>
  <p
    className="s1"
    style={{
      paddingTop: "6pt",
      paddingLeft: "161pt",
      textIndent: "0pt",
      textAlign: "center"
    }}
  >
    DEFINITIONS
  </p>
  <p
    style={{
      paddingTop: "9pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    Capitalized terms in this Privacy Policy, where not defined below, shall
    have the same meaning as in the Parlaye’s{" "}
    <span className="s3">Terms of Use</span> (“<b>Terms and Conditions</b>”). In
    addition:
  </p>
  <ol id="l4">
    <li data-list-text="a)">
      <p
        style={{
          paddingTop: "9pt",
          paddingLeft: "47pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        “<b>Applicable Law</b>” means (for so long as and to the extent that
        they apply to the App) the laws of the U.S. and Canada.
      </p>
    </li>
    <li data-list-text="b)">
      <p
        style={{ paddingLeft: "47pt", textIndent: "-18pt", textAlign: "left" }}
      >
        “<b>California Policy</b>” means the policy at Schedule “A” below,
        applicable to California residents.
      </p>
    </li>
    <li data-list-text="c)">
      <p
        style={{ paddingLeft: "47pt", textIndent: "-18pt", textAlign: "left" }}
      >
        “<b>User</b>” refers to a person or entity that has been granted access
        to the App and who has agreed to be bound by the Terms.
      </p>
    </li>
    <li data-list-text="d)">
      <p
        style={{ paddingLeft: "47pt", textIndent: "-18pt", textAlign: "left" }}
      >
        “<b>User Contributions</b>” refers to content that has been contributed
        to by users of the application, including personal information.
      </p>
    </li>
  </ol>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <p
    className="s1"
    style={{ paddingLeft: "40pt", textIndent: "0pt", textAlign: "center" }}
  >
    INFORMATION WE COLLECT ABOUT YOU
  </p>
  <p
    style={{
      paddingTop: "10pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    We collect and use several types of information from and about you,
    including:
  </p>
  <ol id="l5">
    <li data-list-text="a)">
      <h2
        style={{
          paddingTop: "9pt",
          paddingLeft: "47pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        Personal Information<span className="p">. As defined above.</span>
      </h2>
    </li>
    <li data-list-text="b)">
      <h2
        style={{ paddingLeft: "47pt", textIndent: "-18pt", textAlign: "left" }}
      >
        Payment information
        <span className="p">
          , including credit card or other mode of payment data. Financial
          transactions relating to our App, as and when they are offered, will
          be handled by our third party payment services providers. We will
          share transaction data with our payment services providers only to the
          extent necessary for the purposes of processing your payments and
          related transactions.
        </span>
      </h2>
    </li>
    <li data-list-text="c)">
      <h2
        style={{ paddingLeft: "47pt", textIndent: "-18pt", textAlign: "left" }}
      >
        Non-personal information
        <span className="p">
          , that does not directly or indirectly reveal your identity or
          directly relate to an identifiable individual, such as geolocation
          data, generalized data, demographic information, or statistical or
          aggregated information. Statistical or aggregated data does not
          directly identify a specific person, but we may derive non-personal
          statistical or aggregated data from Personal Information. For example,
          we may aggregate Personal Information to calculate the percentage of
          users accessing a specific App feature.
        </span>
      </h2>
    </li>
    <li data-list-text="d)">
      <h2
        style={{
          paddingTop: "3pt",
          paddingLeft: "47pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        Technical information
        <span className="p">
          , including your login information, device type, browser type and
          version, time zone setting, browser plug-in types and versions,
          operating system and platform, or information about your internet
          connection, the equipment you use to access our App, App pages viewed,
          sections of the App used or viewed, and usage details.
        </span>
      </h2>
    </li>
    <li data-list-text="e)">
      <h2
        style={{ paddingLeft: "47pt", textIndent: "-18pt", textAlign: "left" }}
      >
        Non-personal details about your App interactions
        <span className="p">
          , including the full Uniform Resource Locators (URLs), clickstream to,
          through and from our App (including date and time), products you
          viewed or searched for, page response times, download errors, length
          of visits to certain pages, page interaction information (such as
          scrolling, clicks, and mouse-overs), or methods used to browse away
          from the App.
        </span>
      </h2>
    </li>
  </ol>
  <p
    className="s1"
    style={{
      paddingTop: "6pt",
      paddingLeft: "40pt",
      textIndent: "0pt",
      textAlign: "center"
    }}
  >
    HOW WE COLLECT INFORMATION ABOUT YOU
  </p>
  <p
    className="s4"
    style={{
      paddingTop: "10pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    Methods of Collection
  </p>
  <p
    style={{
      paddingTop: "9pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    We use different methods to collect your Personal Information, including
    through:
  </p>
  <ol id="l6">
    <li data-list-text="a)">
      <h2
        style={{
          paddingTop: "9pt",
          paddingLeft: "47pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        Direct interactions with you when you provide it to us
        <span className="p">
          , for example, by filling in forms, registering for an account, or
          corresponding with us by phone, email, or otherwise.
        </span>
      </h2>
    </li>
    <li data-list-text="b)">
      <h2
        style={{ paddingLeft: "47pt", textIndent: "-18pt", textAlign: "left" }}
      >
        User Contributions
        <span className="p">
          . You may also provide information to be published or displayed
          (hereinafter, “
        </span>
        posted
        <span className="p">
          ”) in public or shared areas of the App or transmitted to other users
          of the App or third parties (collectively, “
        </span>
        User Contributions<span className="p">”).</span>
      </h2>
    </li>
    <li data-list-text="c)">
      <h2
        style={{ paddingLeft: "47pt", textIndent: "-18pt", textAlign: "left" }}
      >
        Automated technologies or interactions
        <span className="p">
          , as you navigate through our App. Information collected automatically
          may include usage details, IP addresses, and information collected
          through cookies, web beacons, and other tracking technologies.
        </span>
      </h2>
    </li>
    <li data-list-text="d)">
      <h2
        style={{ paddingLeft: "47pt", textIndent: "-18pt", textAlign: "left" }}
      >
        Third parties or publicly available sources
        <span className="p">, for example, our business partners.</span>
      </h2>
    </li>
  </ol>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <p style={{ paddingLeft: "11pt", textIndent: "0pt", textAlign: "left" }}>
    Your User Contributions are posted on and transmitted to others at your own
    risk. Please be aware that no security measures are perfect. Additionally,
    we cannot control the actions of other users of the App with whom you may
    choose to share your User Contributions. Therefore, we cannot and do not
    guarantee that unauthorized persons will not view your User Contributions.
  </p>
  <p
    className="s4"
    style={{
      paddingTop: "6pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    Information You Provide to Us
  </p>
  <p
    style={{
      paddingTop: "10pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    The information we collect directly from you on or through our App may
    include:
  </p>
  <ol id="l7">
    <li data-list-text="a)">
      <p
        style={{
          paddingTop: "9pt",
          paddingLeft: "47pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        Information that you provide by filling in forms on our App. This
        includes information provided at the time of subscribing to a
        newsletter, registering through authentication with the App, posting
        material, and/or requesting further services. We may also ask you for
        information when you report a problem with our App.
      </p>
    </li>
    <li data-list-text="b)">
      <p
        style={{ paddingLeft: "47pt", textIndent: "-18pt", textAlign: "left" }}
      >
        Records and copies of your correspondence (including email addresses),
        if you contact us.
      </p>
    </li>
    <li data-list-text="c)">
      <p
        style={{
          paddingLeft: "47pt",
          textIndent: "-18pt",
          lineHeight: "14pt",
          textAlign: "left"
        }}
      >
        Your responses to surveys that we might ask you to complete for research
        purposes.
      </p>
    </li>
    <li data-list-text="d)">
      <p
        style={{ paddingLeft: "47pt", textIndent: "-18pt", textAlign: "left" }}
      >
        Your search queries on the App.
      </p>
    </li>
  </ol>
  <p
    className="s4"
    style={{
      paddingTop: "6pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    Information We Collect Through Third Parties
  </p>
  <p
    style={{
      paddingTop: "9pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "justify"
    }}
  >
    We may collect information about you from third parties with your consent,
    or where otherwise permitted by law. Information collected from third
    parties is used to facilitate the use of the App and various features
    offered on it.
  </p>
  <p
    className="s1"
    style={{
      paddingTop: "3pt",
      paddingLeft: "40pt",
      textIndent: "0pt",
      textAlign: "center"
    }}
  >
    HOW WE USE YOUR INFORMATION
  </p>
  <p
    style={{
      paddingTop: "9pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    We use information that we collect about you or that you provide to us,
    including any Personal Information:
  </p>
  <ol id="l8">
    <li data-list-text="a)">
      <p
        style={{
          paddingTop: "9pt",
          paddingLeft: "47pt",
          textIndent: "-18pt",
          lineHeight: "14pt",
          textAlign: "left"
        }}
      >
        to present our App and its contents to you;
      </p>
    </li>
    <li data-list-text="b)">
      <p
        style={{
          paddingLeft: "47pt",
          textIndent: "-18pt",
          lineHeight: "14pt",
          textAlign: "left"
        }}
      >
        to facilitate contests on the App;
      </p>
    </li>
    <li data-list-text="c)">
      <p
        style={{ paddingLeft: "47pt", textIndent: "-18pt", textAlign: "left" }}
      >
        to provide you with information, products, or services that you request
        from us or that we may consider of interest to you;
      </p>
    </li>
    <li data-list-text="d)">
      <p
        style={{ paddingLeft: "47pt", textIndent: "-18pt", textAlign: "left" }}
      >
        to fulfill the purposes for which you provided the information or that
        were described when it was collected, or any other purpose for which you
        provide it;
      </p>
    </li>
    <li data-list-text="e)">
      <p
        style={{ paddingLeft: "47pt", textIndent: "-18pt", textAlign: "left" }}
      >
        to carry out our obligations and enforce our rights arising from any
        contracts with you, or to comply with legal requirements;
      </p>
    </li>
    <li data-list-text="f)">
      <p
        style={{ paddingLeft: "47pt", textIndent: "-18pt", textAlign: "left" }}
      >
        to notify you by email or other means about changes to our App or any
        products or services we offer or provide through it;
      </p>
    </li>
    <li data-list-text="g)">
      <p
        style={{ paddingLeft: "47pt", textIndent: "-18pt", textAlign: "left" }}
      >
        to improve our App, products or services, marketing, or customer
        relationships and experiences. For this purpose, we may calculate active
        users, daily user engagements and duration of each, App status and
        maintenance, version adoption, acquired users, user retention (weeks,
        percentage of users), audience metrics, country of access and other
        relevant data;
      </p>
    </li>
    <li data-list-text="h)">
      <p
        style={{ paddingLeft: "47pt", textIndent: "-18pt", textAlign: "left" }}
      >
        to allow you to participate in interactive features, social media, or
        similar features on our App;
      </p>
    </li>
    <li data-list-text="i)">
      <p
        style={{ paddingLeft: "47pt", textIndent: "-18pt", textAlign: "left" }}
      >
        to measure or understand the effectiveness of the advertising we serve
        to you and others, and to deliver relevant advertising to you;
      </p>
    </li>
    <li data-list-text="j)">
      <p
        style={{
          paddingLeft: "47pt",
          textIndent: "-18pt",
          lineHeight: "14pt",
          textAlign: "left"
        }}
      >
        to create de-identified data and aggregated data and statistics;
      </p>
    </li>
    <li data-list-text="k)">
      <p
        style={{
          paddingLeft: "47pt",
          textIndent: "-18pt",
          lineHeight: "14pt",
          textAlign: "left"
        }}
      >
        in any other way we may describe when you provide the information; or
      </p>
    </li>
    <li data-list-text="l)">
      <p
        style={{
          paddingLeft: "47pt",
          textIndent: "-18pt",
          lineHeight: "14pt",
          textAlign: "left"
        }}
      >
        for any other purpose with your consent.
      </p>
    </li>
  </ol>
  <p
    className="s1"
    style={{
      paddingTop: "6pt",
      paddingLeft: "40pt",
      textIndent: "0pt",
      textAlign: "center"
    }}
  >
    DISCLOSURE OF YOUR INFORMATION
  </p>
  <p
    style={{
      paddingTop: "9pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    We may disclose aggregated information about our users, and information that
    does not identify any individual, without restriction.
  </p>
  <p
    style={{
      paddingTop: "9pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    We may disclose Personal Information that we collect or you provide as
    described in this Privacy Policy:
  </p>
  <ol id="l9">
    <li data-list-text="a)">
      <p
        style={{
          paddingTop: "9pt",
          paddingLeft: "47pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        to our subsidiaries and affiliates;
      </p>
    </li>
    <li data-list-text="b)">
      <p
        style={{ paddingLeft: "47pt", textIndent: "-18pt", textAlign: "left" }}
      >
        in accordance with Applicable Law, to a buyer or other successor in the
        event of a merger, divestiture, restructuring, reorganization,
        dissolution, or other sale or transfer of some or all of Parlaye’s
        assets, whether as a going concern or as part of bankruptcy,
        liquidation, or similar proceeding, in which Personal Information held
        by Parlaye about our customers and users is among the assets
        transferred;
      </p>
    </li>
    <li data-list-text="c)">
      <p
        style={{ paddingLeft: "47pt", textIndent: "-18pt", textAlign: "left" }}
      >
        to Company personnel including but not limited to executive and
        management personnel and employees including developers, designers,
        researchers, data engineers;
      </p>
    </li>
    <li data-list-text="d)">
      <p
        style={{ paddingLeft: "47pt", textIndent: "-18pt", textAlign: "left" }}
      >
        to contractors, service providers, and other third parties we use to
        support our business (such as analytics and search engine providers that
        assist us with App improvement and optimization) and who are
        contractually obligated to keep Personal Information
      </p>
      <p
        style={{
          paddingTop: "3pt",
          paddingLeft: "47pt",
          textIndent: "0pt",
          textAlign: "left"
        }}
      >
        confidential, use it only for the purposes for which we disclose it to
        them, and to process the Personal Information with the same standards
        set out in this Privacy Policy;
      </p>
    </li>
    <li data-list-text="e)">
      <p
        style={{
          paddingLeft: "47pt",
          textIndent: "-18pt",
          lineHeight: "14pt",
          textAlign: "left"
        }}
      >
        to fulfill the purpose for which you provide it;
      </p>
    </li>
    <li data-list-text="f)">
      <p
        style={{
          paddingLeft: "47pt",
          textIndent: "-18pt",
          lineHeight: "14pt",
          textAlign: "left"
        }}
      >
        for any other purpose disclosed by us when you provide the information;
        or
      </p>
    </li>
    <li data-list-text="g)">
      <p
        style={{ paddingLeft: "47pt", textIndent: "-18pt", textAlign: "left" }}
      >
        with your consent.
      </p>
    </li>
  </ol>
  <p
    style={{
      paddingTop: "6pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    We may also disclose your Personal Information:
  </p>
  <ol id="l10">
    <li data-list-text="a)">
      <p
        style={{
          paddingTop: "10pt",
          paddingLeft: "47pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        to comply with any court order, law, or legal process, including to
        respond to any government or regulatory request, in accordance with
        Applicable Law;
      </p>
    </li>
    <li data-list-text="b)">
      <p
        style={{
          paddingTop: "6pt",
          paddingLeft: "47pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        to enforce or apply our <span className="s3">Terms of Use</span> and
        other agreements, including for billing and collection purposes; or
      </p>
    </li>
    <li data-list-text="c)">
      <p
        style={{
          paddingTop: "6pt",
          paddingLeft: "47pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        if we believe disclosure is necessary or appropriate to protect the
        rights, property, or safety of Parlaye, our customers, or others. This
        includes exchanging information with other companies and organizations
        for the purposes of fraud protection and credit risk reduction.
      </p>
    </li>
  </ol>
  <p
    className="s1"
    style={{
      paddingTop: "6pt",
      paddingLeft: "40pt",
      textIndent: "0pt",
      textAlign: "center"
    }}
  >
    TRANSFERRING YOUR PERSONAL INFORMATION
  </p>
  <p
    style={{
      paddingTop: "9pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    We may transfer Personal Information that we collect or that you provide as
    described in this Privacy Policy to contractors, service providers, and
    other third parties we use to support our business (such as analytics and
    search engine providers that assist us with App improvement and
    optimization), and who we shall contractually require to keep such Personal
    Information confidential on terms no less protective than the terms in this
    Privacy Policy. Such third parties may use it only for the purposes for
    which we disclose it to them, and are required to store and process the
    Personal Information with the same standards of care set out in this Privacy
    Policy.
  </p>
  <p
    style={{
      paddingTop: "9pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    We may process, store, and transfer your Personal Information in and to the
    United States and Canada. In these circumstances, the governments, courts,
    law enforcement, or regulatory agencies of that country may be able to
    obtain access to your Personal Information through the laws of the United
    States and Canada. Whenever we engage a service provider, we require that
    its privacy and security standards adhere to this Privacy Policy and all
    Applicable Law. By submitting your Personal Information or engaging with the
    App, you consent to this transfer, storage, or processing.
  </p>
  <p
    className="s1"
    style={{
      paddingTop: "10pt",
      paddingLeft: "40pt",
      textIndent: "0pt",
      textAlign: "center"
    }}
  >
    CHOICES ABOUT HOW WE USE AND DISCLOSE YOUR INFORMATION
  </p>
  <p
    style={{
      paddingTop: "9pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    We strive to provide you with choices regarding the Personal Information you
    provide to us. We have created mechanisms to provide you with control over
    your information.
  </p>
  <p
    style={{
      paddingTop: "9pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    <a href="mailto:info@parlaye.com" className="s5" target="_blank">
      If you have opted in to receive certain emails from us but no longer wish
      to have your email address used by Parlaye to promote our own or third
      parties' products or services, you can opt-out by checking the relevant
      box located on the form on which we collect your data or at any other time
      by sending us an email stating your request to{" "}
    </a>
    <a href="mailto:info@parlaye.com" className="a" target="_blank">
      info@parlaye.com
    </a>
    . If we have sent you a promotional email, you may unsubscribe by clicking
    the unsubscribe link we have included in the email.
  </p>
  <p
    className="s1"
    style={{
      paddingTop: "3pt",
      paddingLeft: "161pt",
      textIndent: "0pt",
      textAlign: "center"
    }}
  >
    DATA SECURITY
  </p>
  <p
    style={{
      paddingTop: "9pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    The security of your Personal Information is very important to us. We use
    physical, electronic, and administrative measures designed to secure your
    Personal Information from accidental loss and from unauthorized access, use,
    alteration, and disclosure. We store all information you provide to us
    behind firewalls on our secure servers.
  </p>
  <p
    style={{
      paddingTop: "9pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    The safety and security of your Personal Information also depends on you.
    Where we have given you (or where you have chosen) a password for access to
    certain parts of our App, you are responsible for keeping this password
    confidential. We ask you not to share your password with anyone. We urge you
    to be careful about giving out information in public areas of the App like
    message boards, which any App visitor can view.
  </p>
  <p
    style={{
      paddingTop: "10pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    Unfortunately, the transmission of information via the Internet is not
    completely secure. Although we do our best to protect your Personal
    Information, we cannot guarantee the security of your Personal Information
    transmitted to our App. Any transmission of Personal Information is at your
    own risk. We are not responsible for circumvention of any privacy settings
    or security measures contained on the App.
  </p>
  <p
    style={{
      paddingTop: "9pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    Further, should you choose to print out or otherwise replicate Personal
    Information you have submitted to the App, Parlaye will not be responsible
    for any consequent dissemination or loss of such replicated Personal
    Information. Parlaye’s data security measures cannot be extended to physical
    copies or other representations or replicas of Personal Information created
    or derived by you, from the App.
  </p>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <p
    className="s1"
    style={{
      paddingTop: "4pt",
      paddingLeft: "161pt",
      textIndent: "0pt",
      textAlign: "center"
    }}
  >
    DATA RETENTION
  </p>
  <p
    style={{
      paddingTop: "9pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    Except as otherwise permitted or required by Applicable Law or regulation,
    we will only retain your Personal Information for as long as necessary to
    fulfill the purposes we collected it for, including for the purposes of
    satisfying any legal, accounting, or reporting requirements.
  </p>
  <p
    style={{
      paddingTop: "9pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    Under some circumstances, we may anonymize your Personal Information so that
    it can no longer be associated with you. We reserve the right to use such
    anonymous and de-identified data for any legitimate business purpose without
    further notice to you or your consent.
  </p>
  <p
    className="s1"
    style={{
      paddingTop: "9pt",
      paddingLeft: "40pt",
      textIndent: "0pt",
      textAlign: "center"
    }}
  >
    CHILDREN UNDER THE AGE OF 13
  </p>
  <p
    style={{
      paddingTop: "9pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    <a href="mailto:info@parlaye.com" className="s5" target="_blank">
      Our App is not intended to be used by children under 13 years of age. No
      one under age 13 may provide any information to or on the App. We do not
      knowingly collect Personal Information from children under 13. If you are
      under 13, do not use or provide any information on this App or on or
      through any of its features/register on the App, use any of the
      interactive or public comment features of this App, or provide any
      information about yourself to us, including your name, address, telephone
      number, email address, or any screen name or username you may use. If we
      learn we have collected or received Personal Information from a child
      under 13 without verification of parental consent, we will delete that
      information. If you believe we might have any information from or about a
      child under 13, please contact us at{" "}
    </a>
    <a href="mailto:info@parlaye.com" className="a" target="_blank">
      info@parlaye.com
    </a>
    <a href="mailto:info@parlaye.com" className="s5" target="_blank">
      .
    </a>
  </p>
  <p
    style={{
      paddingTop: "10pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    When it comes to the collection of personal information from children under
    the age of 13 years old, the U.S.{" "}
    <i>Children’s Online Privacy Protection Act </i>(COPPA) puts parents in
    control. The
  </p>
  <p
    style={{
      paddingTop: "3pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    Federal Trade Commission, the United States’ consumer protection agency,
    enforces the COPPA Rule, which spells out what operators of websites and
    online services must do to protect children’s privacy and safety online.
    Parlaye will also comply to any other local requirements related to this
    where we operate.
  </p>
  <p
    className="s1"
    style={{
      paddingTop: "10pt",
      paddingLeft: "40pt",
      textIndent: "0pt",
      textAlign: "center"
    }}
  >
    AUTHORIZED USERS IN CALIFORNIA
  </p>
  <p
    style={{
      paddingTop: "9pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "justify"
    }}
  >
    If you are a California resident, California law may provide you with
    specific rights regarding our use of your personal information. To learn
    more about your California privacy rights, visit{" "}
    <span className="s3">https://oag.ca.gov/privacy/ccpa</span>.
  </p>
  <p
    style={{
      paddingTop: "9pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    Schedule “A” to this Privacy Policy contains terms applicable specifically
    to California residents who use the App as Users (“<b>California Policy</b>
    ”). Many parts of the California Policy are identical to those in this
    Privacy Policy. To the extent possible, the California Policy should be read
    in harmony with this Privacy Policy, and if there is any conflict between
    the two, the California Policy shall prevail in relation to any California
    resident’s use of the App as Users.
  </p>
  <p
    style={{
      paddingTop: "10pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    California's “Shine the Light” law (<i>Civil Code </i>Section § 1798.83) and
    the California Consumer Privacy Act of 2018 (“<b>CCPA</b>
    <a href="mailto:info@parlaye.com" className="s5" target="_blank">
      ”) permits users of the App that are California residents to request
      certain information regarding our disclosure of personal information to
      third parties for their direct marketing purposes. To make such a request,
      please send an e-mail to us at{" "}
    </a>
    <a href="mailto:info@parlaye.com" className="a" target="_blank">
      info@parlaye.com
    </a>
    <a href="mailto:info@parlaye.com" className="s5" target="_blank">
      .
    </a>
  </p>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <p
    className="s1"
    style={{
      paddingTop: "10pt",
      paddingLeft: "53pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    ACCESSING AND CORRECTING YOUR PERSONAL INFORMATION
  </p>
  <p
    style={{
      paddingTop: "9pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    It is important that the Personal Information we hold about you is accurate
    and current. Please keep us informed if your Personal Information changes.
    By law you have the right to request access to and to correct the Personal
    Information that we hold about you.
  </p>
  <p
    className="s7"
    style={{
      paddingTop: "9pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    <a href="mailto:info@parlaye.com" className="s5" target="_blank">
      If you want to review, verify, correct, or withdraw consent to the use of
      your Personal Information you may also send us an email at{" "}
    </a>
    <span
      style={{
        color: "#00F",
        fontFamily: '"Times New Roman", serif',
        fontStyle: "normal",
        fontWeight: "normal",
        textDecoration: "underline",
        fontSize: "11pt"
      }}
    >
      info@parlaye.com
    </span>{" "}
    <span className="p">
      to request access to, correct, or delete any Personal Information that you
      have provided to us. We may not accommodate a request to change
      information if we believe the change would violate any law or legal
      requirement or cause the information to be incorrect.
    </span>
  </p>
  <p
    style={{
      paddingTop: "10pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    We may request specific information from you to help us confirm your
    identity and your right to access, and to provide you with the Personal
    Information that we hold about you or make your requested changes.
    Applicable Law may allow or require us to refuse to provide you with access
    to some or all of the Personal Information that we hold about you, or we may
    have destroyed, erased, or made your Personal Information anonymous in
    accordance with our record retention obligations and practices. If we cannot
    provide you with access to your Personal Information, we will inform you of
    the reasons why, subject to any legal or regulatory restrictions.
  </p>
  <p
    style={{
      paddingTop: "9pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    We will provide access to your Personal Information, subject to exceptions
    set out in applicable privacy legislation. Examples of such exceptions
    include:
  </p>
  <ul id="l11">
    <li data-list-text="●">
      <p
        style={{
          paddingTop: "9pt",
          paddingLeft: "47pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        Information protected by solicitor-client privilege.
      </p>
    </li>
    <li data-list-text="●">
      <p
        style={{
          paddingTop: "3pt",
          paddingLeft: "47pt",
          textIndent: "-18pt",
          lineHeight: "14pt",
          textAlign: "left"
        }}
      >
        Information that is part of a formal dispute resolution process.
      </p>
    </li>
    <li data-list-text="●">
      <p
        style={{ paddingLeft: "47pt", textIndent: "-18pt", textAlign: "left" }}
      >
        Information that is about another individual that would reveal their
        Personal Information or confidential commercial information.
      </p>
    </li>
    <li data-list-text="●">
      <p
        style={{
          paddingLeft: "47pt",
          textIndent: "-18pt",
          lineHeight: "14pt",
          textAlign: "left"
        }}
      >
        Information that is prohibitively expensive to provide.
      </p>
    </li>
  </ul>
  <p
    style={{
      paddingTop: "6pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    <a href="mailto:info@parlaye.com" className="s5" target="_blank">
      If you are concerned about our response or would like to correct the
      information provided, you may contact us at{" "}
    </a>
    <a href="mailto:info@parlaye.com" className="a" target="_blank">
      info@parlaye.com
    </a>
    <a href="mailto:info@parlaye.com" className="s5" target="_blank">
      .
    </a>
  </p>
  <p
    style={{
      paddingTop: "9pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    If you delete your User Contributions from the App, copies of your User
    Contributions may remain viewable in cached and archived pages or might have
    been copied or stored by other App users. Proper access and use of
    information provided on the App, including User Contributions, is governed
    by our <span className="s3">Terms of Use.</span>
  </p>
  <p
    className="s1"
    style={{
      paddingTop: "10pt",
      paddingLeft: "40pt",
      textIndent: "0pt",
      textAlign: "center"
    }}
  >
    WITHDRAWING YOUR CONSENT
  </p>
  <p
    style={{
      paddingTop: "9pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    <a href="mailto:info@parlaye.com" className="s5" target="_blank">
      Where you have provided your consent to the collection, use, and transfer
      of your Personal Information, you may have the legal right to withdraw
      your consent under certain circumstances. To withdraw your consent, if
      applicable, contact us at{" "}
    </a>
    <a href="mailto:info@parlaye.com" className="a" target="_blank">
      info@parlaye.com
    </a>
    . Please note that if you withdraw your consent we may not be able to
    provide you with a particular product or service.
  </p>
  <p style={{ paddingLeft: "11pt", textIndent: "0pt", textAlign: "left" }}>
    We will explain the impact to you at the time to help you with your
    decision.
  </p>
  <p
    className="s1"
    style={{
      paddingTop: "10pt",
      paddingLeft: "40pt",
      textIndent: "0pt",
      textAlign: "center"
    }}
  >
    CHANGES TO OUR PRIVACY POLICY
  </p>
  <p
    style={{
      paddingTop: "9pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    It is our policy to post any changes we make to our Privacy Policy on this
    page. If we make material changes to how we treat our users' Personal
    Information, we will notify you through a notice on the App home page.
  </p>
  <p
    style={{
      paddingTop: "9pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    We include the date the Privacy Policy was last revised at the top of the
    page. You are responsible for ensuring we have an up-to-date, active, and
    deliverable email address for you, and for periodically visiting our App and
    this Privacy Policy to check for any changes.
  </p>
  <p
    className="s1"
    style={{
      paddingTop: "9pt",
      paddingLeft: "40pt",
      textIndent: "0pt",
      textAlign: "center"
    }}
  >
    CONTACT INFORMATION AND CHALLENGING COMPLIANCE
  </p>
  <p
    style={{
      paddingTop: "9pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    We welcome your questions, comments, and requests regarding this Privacy
    Policy and our privacy practices. Please contact us at:
  </p>
  <p
    style={{
      paddingTop: "9pt",
      paddingLeft: "47pt",
      textIndent: "0pt",
      lineHeight: "172%",
      textAlign: "left"
    }}
  >
    <a href="mailto:info@parlaye.com" className="s5" target="_blank">
      Privacy Officer{" "}
    </a>
    <a href="mailto:info@parlaye.com" target="_blank">
      info@parlaye.com
    </a>
  </p>
  <p style={{ paddingLeft: "11pt", textIndent: "0pt", textAlign: "left" }}>
    We have procedures in place to receive and respond to complaints or
    inquiries about our handling of Personal Information, our compliance with
    this Privacy Policy, and with applicable privacy laws. To discuss our
    compliance with this Privacy Policy please contact us using the contact
    information listed above.
  </p>
  <h2
    style={{
      paddingTop: "3pt",
      paddingLeft: "181pt",
      textIndent: "0pt",
      lineHeight: "172%",
      textAlign: "center"
    }}
  >
    SCHEDULE “A” CALIFORNIA POLICY
  </h2>
  <p style={{ paddingLeft: "11pt", textIndent: "0pt", textAlign: "left" }}>
    This Privacy Policy for California Residents (“<b>California Policy</b>”)
    supplements the Parlaye (the “<b>Company</b>,” “<b>we</b>”, “<b>us</b>”, “
    <b>our(s)</b>”) main Privacy Policy and applies solely to all visitors,
    users, and others who reside in the State of California (“<b>consumers</b>”
    or “<b>you</b>”). We adopt this notice to comply with the{" "}
    <i>California Consumer Privacy Act of 2018 </i>(“<b>CCPA</b>”) and any terms
    defined in the CCPA have the same meaning when used in this California
    Policy
  </p>
  <p
    style={{
      paddingTop: "9pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    This California Policy does not apply to workforce-related personal
    information collected from California-based employees, job applicants,
    contractors, or similar individuals.
  </p>
  <p
    style={{
      paddingTop: "9pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    Where noted in this California Policy, the CCPA temporarily exempts personal
    information reflecting a written or verbal business-to-business
    communication (“<b>B2B personal information</b>”) from some of its
    requirements.
  </p>
  <p
    className="s8"
    style={{
      paddingTop: "9pt",
      paddingLeft: "161pt",
      textIndent: "0pt",
      textAlign: "center"
    }}
  >
    Information We Collect
  </p>
  <p
    style={{
      paddingTop: "9pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    We collect information that identifies, relates to, describes, references,
    is reasonably capable of being associated with, or could reasonably be
    linked, directly or indirectly, with a particular consumer, household, or
    device (“<b>personal information</b>”). Personal information does not
    include:
  </p>
  <ul id="l12">
    <li data-list-text="●">
      <p
        style={{
          paddingTop: "11pt",
          paddingLeft: "47pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        Publicly available information from government records.
      </p>
    </li>
    <li data-list-text="●">
      <p
        style={{
          paddingTop: "1pt",
          paddingLeft: "47pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        Deidentified or aggregated consumer information.
      </p>
    </li>
    <li data-list-text="●">
      <p
        style={{
          paddingTop: "1pt",
          paddingLeft: "47pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        Information excluded from the CCPA's scope, like:
      </p>
      <ul id="l13">
        <li data-list-text="●">
          <p
            style={{
              paddingTop: "1pt",
              paddingLeft: "65pt",
              textIndent: "-18pt",
              textAlign: "left"
            }}
          >
            health or medical information covered by the U.S.{" "}
            <i>Health Insurance Portability and Accountability Act of 1996 </i>
            (HIPAA) and the{" "}
            <i>California Confidentiality of Medical Information Act </i>(CMIA),
            clinical trial data, or other qualifying research data;
          </p>
        </li>
        <li data-list-text="●">
          <p
            style={{
              paddingTop: "1pt",
              paddingLeft: "65pt",
              textIndent: "-18pt",
              lineHeight: "14pt",
              textAlign: "left"
            }}
          >
            personal information covered by certain sector-specific privacy
            laws, including the
          </p>
          <p
            style={{
              paddingLeft: "65pt",
              textIndent: "0pt",
              textAlign: "left"
            }}
          >
            U.S. <i>Fair Credit Reporting Act </i>(FCRA), the{" "}
            <i>Gramm-Leach-Bliley Act </i>(GLBA) or{" "}
            <i>California Financial Information Privacy Act </i>(FIPA), and the{" "}
            <i>Driver's Privacy Protection Act of 1994</i>.
          </p>
          <p
            style={{
              paddingTop: "6pt",
              paddingLeft: "11pt",
              textIndent: "0pt",
              textAlign: "left"
            }}
          >
            In particular, we have collected the following categories of
            personal information from consumers within the last twelve (12)
            months:
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <table
            style={{ borderCollapse: "collapse", marginLeft: "5.6317pt" }}
            cellSpacing={0}
          >
            <tbody>
              <tr style={{ height: "30pt" }}>
                <td
                  style={{
                    width: "94pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt"
                  }}
                >
                  <p
                    className="s9"
                    style={{
                      paddingTop: "6pt",
                      paddingLeft: "24pt",
                      textIndent: "0pt",
                      textAlign: "left"
                    }}
                  >
                    Category
                  </p>
                </td>
                <td
                  style={{
                    width: "280pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt"
                  }}
                >
                  <p
                    className="s9"
                    style={{
                      paddingTop: "6pt",
                      paddingLeft: "115pt",
                      paddingRight: "115pt",
                      textIndent: "0pt",
                      textAlign: "center"
                    }}
                  >
                    Examples
                  </p>
                </td>
                <td
                  style={{
                    width: "94pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt"
                  }}
                >
                  <p
                    className="s9"
                    style={{
                      paddingTop: "6pt",
                      paddingLeft: "23pt",
                      textIndent: "0pt",
                      textAlign: "left"
                    }}
                  >
                    Collected
                  </p>
                </td>
              </tr>
              <tr style={{ height: "72pt" }}>
                <td
                  style={{
                    width: "94pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt"
                  }}
                >
                  <p
                    className="s9"
                    style={{
                      paddingTop: "6pt",
                      paddingLeft: "5pt",
                      textIndent: "0pt",
                      textAlign: "left"
                    }}
                  >
                    A. Identifiers.
                  </p>
                </td>
                <td
                  style={{
                    width: "280pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt"
                  }}
                >
                  <p
                    className="s9"
                    style={{
                      paddingTop: "5pt",
                      paddingLeft: "5pt",
                      paddingRight: "8pt",
                      textIndent: "0pt",
                      textAlign: "left"
                    }}
                  >
                    A real name, alias, postal address, unique personal
                    identifier, online identifier, Internet Protocol address,
                    email address, account name, or other similar identifiers.
                  </p>
                </td>
                <td
                  style={{
                    width: "94pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt"
                  }}
                >
                  <p
                    className="s9"
                    style={{
                      paddingTop: "6pt",
                      paddingLeft: "5pt",
                      textIndent: "0pt",
                      textAlign: "left"
                    }}
                  >
                    YES
                  </p>
                </td>
              </tr>
              <tr style={{ height: "34pt" }}>
                <td
                  style={{
                    width: "94pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt"
                  }}
                >
                  <p
                    className="s9"
                    style={{
                      paddingTop: "4pt",
                      paddingLeft: "5pt",
                      textIndent: "0pt",
                      lineHeight: "14pt",
                      textAlign: "left"
                    }}
                  >
                    B. Personal information
                  </p>
                </td>
                <td
                  style={{
                    width: "280pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt"
                  }}
                >
                  <p
                    className="s9"
                    style={{
                      paddingTop: "4pt",
                      paddingLeft: "5pt",
                      textIndent: "0pt",
                      lineHeight: "14pt",
                      textAlign: "left"
                    }}
                  >
                    A name, signature, address, telephone number, passport
                    number, driver's license or state identification card
                  </p>
                </td>
                <td
                  style={{
                    width: "94pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt"
                  }}
                >
                  <p
                    className="s9"
                    style={{
                      paddingTop: "6pt",
                      paddingLeft: "5pt",
                      textIndent: "0pt",
                      textAlign: "left"
                    }}
                  >
                    YES
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <table
            style={{ borderCollapse: "collapse", marginLeft: "5.6317pt" }}
            cellSpacing={0}
          >
            <tbody>
              <tr style={{ height: "93pt" }}>
                <td
                  style={{
                    width: "94pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt"
                  }}
                >
                  <p
                    className="s9"
                    style={{
                      paddingLeft: "5pt",
                      paddingRight: "8pt",
                      textIndent: "0pt",
                      textAlign: "left"
                    }}
                  >
                    categories listed in the California Customer Records statute
                    (Cal. Civ. Code
                  </p>
                  <p
                    className="s9"
                    style={{
                      paddingLeft: "5pt",
                      textIndent: "0pt",
                      textAlign: "left"
                    }}
                  >
                    § 1798.80(e)).
                  </p>
                </td>
                <td
                  style={{
                    width: "280pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt"
                  }}
                >
                  <p
                    className="s9"
                    style={{
                      paddingLeft: "5pt",
                      paddingRight: "8pt",
                      textIndent: "0pt",
                      textAlign: "left"
                    }}
                  >
                    number, bank account number, credit card number, debit card
                    number, or any other financial information.
                  </p>
                  <p
                    className="s9"
                    style={{
                      paddingTop: "9pt",
                      paddingLeft: "5pt",
                      paddingRight: "8pt",
                      textIndent: "0pt",
                      textAlign: "left"
                    }}
                  >
                    Some personal information included in this category may
                    overlap with other categories.
                  </p>
                </td>
                <td
                  style={{
                    width: "94pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt"
                  }}
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
              </tr>
              <tr style={{ height: "127pt" }}>
                <td
                  style={{
                    width: "94pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt"
                  }}
                >
                  <p
                    className="s9"
                    style={{
                      paddingTop: "5pt",
                      paddingLeft: "5pt",
                      paddingRight: "8pt",
                      textIndent: "0pt",
                      textAlign: "left"
                    }}
                  >
                    C. Protected classification characteristics under California
                    or federal law.
                  </p>
                </td>
                <td
                  style={{
                    width: "280pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt"
                  }}
                >
                  <p
                    className="s9"
                    style={{
                      paddingTop: "5pt",
                      paddingLeft: "5pt",
                      paddingRight: "8pt",
                      textIndent: "0pt",
                      textAlign: "left"
                    }}
                  >
                    Age (40 years or older), race, color, ancestry, national
                    origin, citizenship, religion or creed, marital status,
                    medical condition, physical or mental disability, sex
                    (including gender, gender identity, gender expression,
                    pregnancy or childbirth and related medical conditions),
                    sexual orientation, veteran or military status, genetic
                    information (including familial genetic information).
                  </p>
                </td>
                <td
                  style={{
                    width: "94pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt"
                  }}
                >
                  <p
                    className="s9"
                    style={{
                      paddingTop: "6pt",
                      paddingLeft: "5pt",
                      textIndent: "0pt",
                      textAlign: "left"
                    }}
                  >
                    NO
                  </p>
                </td>
              </tr>
              <tr style={{ height: "58pt" }}>
                <td
                  style={{
                    width: "94pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt"
                  }}
                >
                  <p
                    className="s9"
                    style={{
                      paddingTop: "6pt",
                      paddingLeft: "5pt",
                      paddingRight: "13pt",
                      textIndent: "0pt",
                      textAlign: "left"
                    }}
                  >
                    D. Commercial information.
                  </p>
                </td>
                <td
                  style={{
                    width: "280pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt"
                  }}
                >
                  <p
                    className="s9"
                    style={{
                      paddingTop: "6pt",
                      paddingLeft: "5pt",
                      textIndent: "0pt",
                      textAlign: "left"
                    }}
                  >
                    Records of personal property, products or services
                    purchased, obtained, or considered, or other purchasing or
                    consuming histories or tendencies.
                  </p>
                </td>
                <td
                  style={{
                    width: "94pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt"
                  }}
                >
                  <p
                    className="s9"
                    style={{
                      paddingTop: "6pt",
                      paddingLeft: "5pt",
                      textIndent: "0pt",
                      textAlign: "left"
                    }}
                  >
                    NO
                  </p>
                </td>
              </tr>
              <tr style={{ height: "99pt" }}>
                <td
                  style={{
                    width: "94pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt"
                  }}
                >
                  <p
                    className="s9"
                    style={{
                      paddingTop: "5pt",
                      paddingLeft: "5pt",
                      paddingRight: "25pt",
                      textIndent: "0pt",
                      textAlign: "left"
                    }}
                  >
                    E. Biometric information.
                  </p>
                </td>
                <td
                  style={{
                    width: "280pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt"
                  }}
                >
                  <p
                    className="s9"
                    style={{
                      paddingTop: "5pt",
                      paddingLeft: "5pt",
                      paddingRight: "8pt",
                      textIndent: "0pt",
                      textAlign: "left"
                    }}
                  >
                    Genetic, physiological, behavioral, and biological
                    characteristics, or activity patterns used to extract a
                    template or other identifier or identifying information,
                    such as, fingerprints, faceprints, and voiceprints, iris or
                    retina scans, keystroke, gait, or other physical patterns,
                    and sleep, health, or exercise data.
                  </p>
                </td>
                <td
                  style={{
                    width: "94pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt"
                  }}
                >
                  <p
                    className="s9"
                    style={{
                      paddingTop: "6pt",
                      paddingLeft: "5pt",
                      textIndent: "0pt",
                      textAlign: "left"
                    }}
                  >
                    NO
                  </p>
                </td>
              </tr>
              <tr style={{ height: "58pt" }}>
                <td
                  style={{
                    width: "94pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt"
                  }}
                >
                  <p
                    className="s9"
                    style={{
                      paddingTop: "5pt",
                      paddingLeft: "5pt",
                      paddingRight: "5pt",
                      textIndent: "0pt",
                      textAlign: "left"
                    }}
                  >
                    F. Internet or other similar network activity.
                  </p>
                </td>
                <td
                  style={{
                    width: "280pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt"
                  }}
                >
                  <p
                    className="s9"
                    style={{
                      paddingTop: "5pt",
                      paddingLeft: "5pt",
                      paddingRight: "8pt",
                      textIndent: "0pt",
                      textAlign: "left"
                    }}
                  >
                    Browsing history, search history, information on a
                    consumer's interaction with a website, application, or
                    advertisement.
                  </p>
                </td>
                <td
                  style={{
                    width: "94pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt"
                  }}
                >
                  <p
                    className="s9"
                    style={{
                      paddingTop: "6pt",
                      paddingLeft: "5pt",
                      textIndent: "0pt",
                      textAlign: "left"
                    }}
                  >
                    YES
                  </p>
                </td>
              </tr>
              <tr style={{ height: "44pt" }}>
                <td
                  style={{
                    width: "94pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt"
                  }}
                >
                  <p
                    className="s9"
                    style={{
                      paddingTop: "5pt",
                      paddingLeft: "5pt",
                      paddingRight: "13pt",
                      textIndent: "0pt",
                      textAlign: "left"
                    }}
                  >
                    G. Geolocation data.
                  </p>
                </td>
                <td
                  style={{
                    width: "280pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt"
                  }}
                >
                  <p
                    className="s9"
                    style={{
                      paddingTop: "6pt",
                      paddingLeft: "5pt",
                      textIndent: "0pt",
                      textAlign: "left"
                    }}
                  >
                    Physical location or movements.
                  </p>
                </td>
                <td
                  style={{
                    width: "94pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt"
                  }}
                >
                  <p
                    className="s9"
                    style={{
                      paddingTop: "6pt",
                      paddingLeft: "5pt",
                      textIndent: "0pt",
                      textAlign: "left"
                    }}
                  >
                    YES
                  </p>
                </td>
              </tr>
              <tr style={{ height: "44pt" }}>
                <td
                  style={{
                    width: "94pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt"
                  }}
                >
                  <p
                    className="s9"
                    style={{
                      paddingTop: "6pt",
                      paddingLeft: "5pt",
                      textIndent: "0pt",
                      textAlign: "left"
                    }}
                  >
                    H. Sensory data.
                  </p>
                </td>
                <td
                  style={{
                    width: "280pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt"
                  }}
                >
                  <p
                    className="s9"
                    style={{
                      paddingTop: "5pt",
                      paddingLeft: "5pt",
                      paddingRight: "8pt",
                      textIndent: "0pt",
                      textAlign: "left"
                    }}
                  >
                    Audio, electronic, visual, thermal, olfactory, or similar
                    information.
                  </p>
                </td>
                <td
                  style={{
                    width: "94pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt"
                  }}
                >
                  <p
                    className="s9"
                    style={{
                      paddingTop: "6pt",
                      paddingLeft: "5pt",
                      textIndent: "0pt",
                      textAlign: "left"
                    }}
                  >
                    NO
                  </p>
                </td>
              </tr>
              <tr style={{ height: "72pt" }}>
                <td
                  style={{
                    width: "94pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt"
                  }}
                >
                  <p
                    className="s9"
                    style={{
                      paddingTop: "5pt",
                      paddingLeft: "5pt",
                      paddingRight: "10pt",
                      textIndent: "0pt",
                      textAlign: "left"
                    }}
                  >
                    I. Professional or employment-related information.
                  </p>
                </td>
                <td
                  style={{
                    width: "280pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt"
                  }}
                >
                  <p
                    className="s9"
                    style={{
                      paddingTop: "6pt",
                      paddingLeft: "5pt",
                      textIndent: "0pt",
                      textAlign: "left"
                    }}
                  >
                    Current or past job history or performance evaluations.
                  </p>
                </td>
                <td
                  style={{
                    width: "94pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt"
                  }}
                >
                  <p
                    className="s9"
                    style={{
                      paddingTop: "6pt",
                      paddingLeft: "5pt",
                      textIndent: "0pt",
                      textAlign: "left"
                    }}
                  >
                    NO
                  </p>
                </td>
              </tr>
              <tr style={{ height: "48pt" }}>
                <td
                  style={{
                    width: "94pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt"
                  }}
                >
                  <p
                    className="s9"
                    style={{
                      paddingTop: "5pt",
                      paddingLeft: "5pt",
                      paddingRight: "21pt",
                      textIndent: "0pt",
                      textAlign: "left"
                    }}
                  >
                    J. Non-public education
                  </p>
                  <p
                    className="s9"
                    style={{
                      paddingLeft: "5pt",
                      textIndent: "0pt",
                      lineHeight: "13pt",
                      textAlign: "left"
                    }}
                  >
                    information (per
                  </p>
                </td>
                <td
                  style={{
                    width: "280pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt"
                  }}
                >
                  <p
                    className="s9"
                    style={{
                      paddingTop: "5pt",
                      paddingLeft: "5pt",
                      paddingRight: "8pt",
                      textIndent: "0pt",
                      textAlign: "left"
                    }}
                  >
                    Education records directly related to a student maintained
                    by an educational institution or party acting
                  </p>
                  <p
                    className="s9"
                    style={{
                      paddingLeft: "5pt",
                      textIndent: "0pt",
                      lineHeight: "13pt",
                      textAlign: "left"
                    }}
                  >
                    on its behalf, such as grades, transcripts, class lists,
                  </p>
                </td>
                <td
                  style={{
                    width: "94pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt"
                  }}
                >
                  <p
                    className="s9"
                    style={{
                      paddingTop: "6pt",
                      paddingLeft: "5pt",
                      textIndent: "0pt",
                      textAlign: "left"
                    }}
                  >
                    NO
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <table
            style={{ borderCollapse: "collapse", marginLeft: "5.6317pt" }}
            cellSpacing={0}
          >
            <tbody>
              <tr style={{ height: "107pt" }}>
                <td
                  style={{
                    width: "94pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt"
                  }}
                >
                  <p
                    className="s9"
                    style={{
                      paddingLeft: "5pt",
                      paddingRight: "8pt",
                      textIndent: "0pt",
                      textAlign: "left"
                    }}
                  >
                    the Family Educational Rights and Privacy Act (20
                  </p>
                  <p
                    className="s9"
                    style={{
                      paddingLeft: "5pt",
                      paddingRight: "15pt",
                      textIndent: "0pt",
                      textAlign: "left"
                    }}
                  >
                    U.S.C. Section 1232g, 34
                  </p>
                  <p
                    className="s9"
                    style={{
                      paddingLeft: "5pt",
                      textIndent: "0pt",
                      lineHeight: "14pt",
                      textAlign: "left"
                    }}
                  >
                    C.F.R. Part 99)).
                  </p>
                </td>
                <td
                  style={{
                    width: "280pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt"
                  }}
                >
                  <p
                    className="s9"
                    style={{
                      paddingLeft: "5pt",
                      paddingRight: "8pt",
                      textIndent: "0pt",
                      textAlign: "left"
                    }}
                  >
                    student schedules, student identification codes, student
                    financial information, or student disciplinary records.
                  </p>
                </td>
                <td
                  style={{
                    width: "94pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt"
                  }}
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
              </tr>
              <tr style={{ height: "21pt" }}>
                <td
                  style={{
                    width: "94pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt"
                  }}
                >
                  <p
                    className="s9"
                    style={{
                      paddingTop: "5pt",
                      paddingLeft: "5pt",
                      textIndent: "0pt",
                      lineHeight: "13pt",
                      textAlign: "left"
                    }}
                  >
                    K. Inferences
                  </p>
                </td>
                <td
                  style={{
                    width: "280pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt"
                  }}
                >
                  <p
                    className="s9"
                    style={{
                      paddingTop: "5pt",
                      paddingLeft: "5pt",
                      textIndent: "0pt",
                      lineHeight: "13pt",
                      textAlign: "left"
                    }}
                  >
                    Profile reflecting a person's preferences, characteristics,
                  </p>
                </td>
                <td
                  style={{
                    width: "94pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt"
                  }}
                >
                  <p
                    className="s9"
                    style={{
                      paddingTop: "6pt",
                      paddingLeft: "5pt",
                      textIndent: "0pt",
                      lineHeight: "13pt",
                      textAlign: "left"
                    }}
                  >
                    NO
                  </p>
                </td>
              </tr>
              <tr style={{ height: "14pt" }}>
                <td
                  style={{
                    width: "94pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt"
                  }}
                >
                  <p
                    className="s9"
                    style={{
                      paddingLeft: "5pt",
                      textIndent: "0pt",
                      lineHeight: "13pt",
                      textAlign: "left"
                    }}
                  >
                    drawn from
                  </p>
                </td>
                <td
                  style={{
                    width: "280pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt"
                  }}
                >
                  <p
                    className="s9"
                    style={{
                      paddingLeft: "5pt",
                      textIndent: "0pt",
                      lineHeight: "13pt",
                      textAlign: "left"
                    }}
                  >
                    psychological trends, predispositions, behavior,
                  </p>
                </td>
                <td
                  style={{
                    width: "94pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt"
                  }}
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
              </tr>
              <tr style={{ height: "14pt" }}>
                <td
                  style={{
                    width: "94pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt"
                  }}
                >
                  <p
                    className="s9"
                    style={{
                      paddingLeft: "5pt",
                      textIndent: "0pt",
                      lineHeight: "13pt",
                      textAlign: "left"
                    }}
                  >
                    other personal
                  </p>
                </td>
                <td
                  style={{
                    width: "280pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt"
                  }}
                >
                  <p
                    className="s9"
                    style={{
                      paddingLeft: "5pt",
                      textIndent: "0pt",
                      lineHeight: "13pt",
                      textAlign: "left"
                    }}
                  >
                    attitudes, intelligence, abilities, and aptitudes.
                  </p>
                </td>
                <td
                  style={{
                    width: "94pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt"
                  }}
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
              </tr>
              <tr style={{ height: "24pt" }}>
                <td
                  style={{
                    width: "94pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt"
                  }}
                >
                  <p
                    className="s9"
                    style={{
                      paddingLeft: "5pt",
                      textIndent: "0pt",
                      lineHeight: "14pt",
                      textAlign: "left"
                    }}
                  >
                    information.
                  </p>
                </td>
                <td
                  style={{
                    width: "280pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt"
                  }}
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
                <td
                  style={{
                    width: "94pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt"
                  }}
                >
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
          <p
            style={{
              paddingTop: "5pt",
              paddingLeft: "11pt",
              textIndent: "0pt",
              textAlign: "left"
            }}
          >
            We obtain the categories of personal information listed above from
            the following categories of sources:
          </p>
        </li>
      </ul>
    </li>
    <li data-list-text="●">
      <p
        style={{
          paddingTop: "11pt",
          paddingLeft: "47pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        Directly from you. For example, from forms you complete or products and
        services you purchase.
      </p>
    </li>
    <li data-list-text="●">
      <p
        style={{
          paddingTop: "1pt",
          paddingLeft: "47pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        Indirectly from you. For example, from observing your actions on our
        App.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        className="s8"
        style={{ paddingLeft: "161pt", textIndent: "0pt", textAlign: "center" }}
      >
        Use of Personal Information
      </p>
      <p
        style={{
          paddingTop: "9pt",
          paddingLeft: "11pt",
          textIndent: "0pt",
          textAlign: "left"
        }}
      >
        We may use or disclose the personal information we collect for one or
        more of the following purposes:
      </p>
    </li>
    <li data-list-text="●">
      <p
        style={{
          paddingTop: "10pt",
          paddingLeft: "47pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        To fulfill or meet the reason you provided the information. For example,
        if you share your name and contact information to request a price quote
        or ask a question about our products or services, we will use that
        personal information to respond to your inquiry. If you provide your
        personal information to purchase a product or service, we will use that
        information to process your payment and facilitate delivery. We may also
        save your information to facilitate new product orders or process
        returns.
      </p>
    </li>
    <li data-list-text="●">
      <p
        style={{
          paddingTop: "1pt",
          paddingLeft: "47pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        To provide, support, personalize, and develop our App, products, and
        services.
      </p>
    </li>
    <li data-list-text="●">
      <p
        style={{
          paddingTop: "1pt",
          paddingLeft: "47pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        To create, maintain, customize, and secure your account with us.
      </p>
    </li>
    <li data-list-text="●">
      <p
        style={{
          paddingTop: "1pt",
          paddingLeft: "47pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        To process your requests, purchases, transactions, and payments and
        prevent transactional fraud.
      </p>
    </li>
    <li data-list-text="●">
      <p
        style={{
          paddingTop: "1pt",
          paddingLeft: "47pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        To provide you with support and to respond to your inquiries, including
        to investigate and address your concerns and monitor and improve our
        responses.
      </p>
    </li>
    <li data-list-text="●">
      <p
        style={{
          paddingTop: "1pt",
          paddingLeft: "47pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        To personalize your App experience and to deliver content and product
        and service offerings relevant to your interests, including targeted
        offers and ads through our App, third-party sites, and via email or text
        message (with your consent, where required by law).
      </p>
    </li>
    <li data-list-text="●">
      <p
        style={{
          paddingTop: "1pt",
          paddingLeft: "47pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        To help maintain the safety, security, and integrity of our App,
        products and services, databases and other technology assets, and
        business.
      </p>
    </li>
    <li data-list-text="●">
      <p
        style={{
          paddingTop: "1pt",
          paddingLeft: "47pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        For testing, research, analysis, and product development, including to
        develop and improve our App, products, and services.
      </p>
    </li>
    <li data-list-text="●">
      <p
        style={{
          paddingTop: "5pt",
          paddingLeft: "47pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        To respond to law enforcement requests and as required by Applicable
        Law, court order, or governmental regulations.
      </p>
    </li>
    <li data-list-text="●">
      <p
        style={{
          paddingTop: "1pt",
          paddingLeft: "47pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        As described to you when collecting your personal information or as
        otherwise set forth in the CCPA.
      </p>
    </li>
    <li data-list-text="●">
      <p
        style={{
          paddingTop: "1pt",
          paddingLeft: "47pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        To evaluate or conduct a merger, divestiture, restructuring,
        reorganization, dissolution, or other sale or transfer of some or all of
        our assets, whether as a going concern or as part of bankruptcy,
        liquidation, or similar proceeding, in which personal information held
        by us about our App users is among the assets transferred.
      </p>
    </li>
  </ul>
  <p
    style={{
      paddingTop: "5pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "justify"
    }}
  >
    We will not collect additional categories of personal information or use the
    personal information we collected for materially different, unrelated, or
    incompatible purposes without providing you notice.
  </p>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <p
    className="s8"
    style={{
      paddingTop: "4pt",
      paddingLeft: "161pt",
      textIndent: "0pt",
      textAlign: "center"
    }}
  >
    Sharing Personal Information
  </p>
  <p
    style={{
      paddingTop: "9pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "justify"
    }}
  >
    <a href="mailto:info@parlaye.com" className="s5" target="_blank">
      We may share your personal information by disclosing it, in both original
      or anonymized form, to a third party for a business purpose. If you wish
      to specifically opt out of this sharing, please email us at{" "}
    </a>
    <a href="mailto:info@parlaye.com" className="a" target="_blank">
      info@parlaye.com
    </a>
    <a href="mailto:info@parlaye.com" className="s5" target="_blank">
      .
    </a>
  </p>
  <p
    style={{
      paddingTop: "9pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    We only make business purpose disclosures under written contracts that
    describe the purposes, require the recipient to keep the personal
    information confidential, and prohibit using the disclosed information for
    any purpose except performing the contract. In the preceding twelve
  </p>
  <p style={{ paddingLeft: "11pt", textIndent: "0pt", textAlign: "left" }}>
    (12) months, the Company has disclosed personal information for a business
    purpose to the categories of third parties indicated in the chart below.
  </p>
  <p
    style={{
      paddingTop: "9pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    We do not sell personal information.
  </p>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <table
    style={{ borderCollapse: "collapse", marginLeft: "5.6317pt" }}
    cellSpacing={0}
  >
    <tbody>
      <tr style={{ height: "30pt" }}>
        <td
          style={{
            width: "135pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
          rowSpan={2}
        >
          <p
            className="s9"
            style={{
              paddingTop: "5pt",
              paddingLeft: "45pt",
              paddingRight: "16pt",
              textIndent: "-28pt",
              textAlign: "left"
            }}
          >
            Personal Information Category
          </p>
        </td>
        <td
          style={{
            width: "333pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
          colSpan={2}
        >
          <p
            className="s9"
            style={{
              paddingTop: "6pt",
              paddingLeft: "81pt",
              textIndent: "0pt",
              textAlign: "left"
            }}
          >
            Category of Third-Party Recipients
          </p>
        </td>
      </tr>
      <tr style={{ height: "30pt" }}>
        <td
          style={{
            width: "171pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s9"
            style={{
              paddingTop: "6pt",
              paddingLeft: "4pt",
              paddingRight: "4pt",
              textIndent: "0pt",
              textAlign: "center"
            }}
          >
            Business Purpose Disclosures
          </p>
        </td>
        <td
          style={{
            width: "162pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s9"
            style={{
              paddingTop: "6pt",
              paddingLeft: "67pt",
              paddingRight: "67pt",
              textIndent: "0pt",
              textAlign: "center"
            }}
          >
            Sales
          </p>
        </td>
      </tr>
      <tr style={{ height: "30pt" }}>
        <td
          style={{
            width: "135pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s9"
            style={{
              paddingTop: "6pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              textAlign: "left"
            }}
          >
            A: Identifiers.
          </p>
        </td>
        <td
          style={{
            width: "171pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s9"
            style={{
              paddingTop: "6pt",
              paddingLeft: "4pt",
              paddingRight: "8pt",
              textIndent: "0pt",
              textAlign: "center"
            }}
          >
            Registration and use of the App.
          </p>
        </td>
        <td
          style={{
            width: "162pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s9"
            style={{
              paddingTop: "6pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              textAlign: "left"
            }}
          >
            None.
          </p>
        </td>
      </tr>
      <tr style={{ height: "58pt" }}>
        <td
          style={{
            width: "135pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s9"
            style={{
              paddingTop: "5pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              textAlign: "left"
            }}
          >
            B: California Customer Records personal information categories.
          </p>
        </td>
        <td
          style={{
            width: "171pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s9"
            style={{
              paddingTop: "6pt",
              paddingLeft: "4pt",
              paddingRight: "8pt",
              textIndent: "0pt",
              textAlign: "center"
            }}
          >
            Registration and use of the App.
          </p>
        </td>
        <td
          style={{
            width: "162pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s9"
            style={{
              paddingTop: "6pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              textAlign: "left"
            }}
          >
            None.
          </p>
        </td>
      </tr>
      <tr style={{ height: "72pt" }}>
        <td
          style={{
            width: "135pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s9"
            style={{
              paddingTop: "5pt",
              paddingLeft: "5pt",
              paddingRight: "7pt",
              textIndent: "0pt",
              textAlign: "left"
            }}
          >
            C: Protected classification characteristics under California or
            federal law.
          </p>
        </td>
        <td
          style={{
            width: "171pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s9"
            style={{
              paddingTop: "6pt",
              paddingLeft: "4pt",
              paddingRight: "8pt",
              textIndent: "0pt",
              textAlign: "center"
            }}
          >
            Registration and use of the App.
          </p>
        </td>
        <td
          style={{
            width: "162pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s9"
            style={{
              paddingTop: "6pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              textAlign: "left"
            }}
          >
            None.
          </p>
        </td>
      </tr>
      <tr style={{ height: "44pt" }}>
        <td
          style={{
            width: "135pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s9"
            style={{
              paddingTop: "5pt",
              paddingLeft: "5pt",
              paddingRight: "54pt",
              textIndent: "0pt",
              textAlign: "left"
            }}
          >
            D: Commercial information.
          </p>
        </td>
        <td
          style={{
            width: "171pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s9"
            style={{
              paddingTop: "6pt",
              paddingLeft: "4pt",
              paddingRight: "8pt",
              textIndent: "0pt",
              textAlign: "center"
            }}
          >
            Registration and use of the App.
          </p>
        </td>
        <td
          style={{
            width: "162pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s9"
            style={{
              paddingTop: "6pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              textAlign: "left"
            }}
          >
            None.
          </p>
        </td>
      </tr>
    </tbody>
  </table>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <table
    style={{ borderCollapse: "collapse", marginLeft: "5.6317pt" }}
    cellSpacing={0}
  >
    <tbody>
      <tr style={{ height: "44pt" }}>
        <td
          style={{
            width: "135pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s9"
            style={{
              paddingTop: "5pt",
              paddingLeft: "5pt",
              paddingRight: "66pt",
              textIndent: "0pt",
              textAlign: "left"
            }}
          >
            E: Biometric information.
          </p>
        </td>
        <td
          style={{
            width: "171pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s9"
            style={{
              paddingTop: "6pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              textAlign: "left"
            }}
          >
            None.
          </p>
        </td>
        <td
          style={{
            width: "162pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s9"
            style={{
              paddingTop: "6pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              textAlign: "left"
            }}
          >
            None.
          </p>
        </td>
      </tr>
      <tr style={{ height: "44pt" }}>
        <td
          style={{
            width: "135pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s9"
            style={{
              paddingTop: "5pt",
              paddingLeft: "5pt",
              paddingRight: "7pt",
              textIndent: "0pt",
              textAlign: "left"
            }}
          >
            F: Internet or other similar network activity.
          </p>
        </td>
        <td
          style={{
            width: "171pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s9"
            style={{
              paddingTop: "6pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              textAlign: "left"
            }}
          >
            Registration and use of the App.
          </p>
        </td>
        <td
          style={{
            width: "162pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s9"
            style={{
              paddingTop: "6pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              textAlign: "left"
            }}
          >
            None.
          </p>
        </td>
      </tr>
      <tr style={{ height: "30pt" }}>
        <td
          style={{
            width: "135pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s9"
            style={{
              paddingTop: "6pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              textAlign: "left"
            }}
          >
            G: Geolocation data.
          </p>
        </td>
        <td
          style={{
            width: "171pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s9"
            style={{
              paddingTop: "6pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              textAlign: "left"
            }}
          >
            None.
          </p>
        </td>
        <td
          style={{
            width: "162pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s9"
            style={{
              paddingTop: "6pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              textAlign: "left"
            }}
          >
            None.
          </p>
        </td>
      </tr>
      <tr style={{ height: "30pt" }}>
        <td
          style={{
            width: "135pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s9"
            style={{
              paddingTop: "6pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              textAlign: "left"
            }}
          >
            H: Sensory data.
          </p>
        </td>
        <td
          style={{
            width: "171pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s9"
            style={{
              paddingTop: "6pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              textAlign: "left"
            }}
          >
            None.
          </p>
        </td>
        <td
          style={{
            width: "162pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s9"
            style={{
              paddingTop: "6pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              textAlign: "left"
            }}
          >
            None.
          </p>
        </td>
      </tr>
      <tr style={{ height: "58pt" }}>
        <td
          style={{
            width: "135pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s9"
            style={{
              paddingTop: "5pt",
              paddingLeft: "5pt",
              paddingRight: "31pt",
              textIndent: "0pt",
              textAlign: "left"
            }}
          >
            I: Professional or employment-related information.
          </p>
        </td>
        <td
          style={{
            width: "171pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s9"
            style={{
              paddingTop: "6pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              textAlign: "left"
            }}
          >
            None.
          </p>
        </td>
        <td
          style={{
            width: "162pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s9"
            style={{
              paddingTop: "6pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              textAlign: "left"
            }}
          >
            None.
          </p>
        </td>
      </tr>
      <tr style={{ height: "44pt" }}>
        <td
          style={{
            width: "135pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s9"
            style={{
              paddingTop: "5pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              textAlign: "left"
            }}
          >
            J: Non-public education information.
          </p>
        </td>
        <td
          style={{
            width: "171pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s9"
            style={{
              paddingTop: "6pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              textAlign: "left"
            }}
          >
            None.
          </p>
        </td>
        <td
          style={{
            width: "162pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s9"
            style={{
              paddingTop: "6pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              textAlign: "left"
            }}
          >
            None.
          </p>
        </td>
      </tr>
      <tr style={{ height: "58pt" }}>
        <td
          style={{
            width: "135pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s9"
            style={{
              paddingTop: "5pt",
              paddingLeft: "5pt",
              paddingRight: "30pt",
              textIndent: "0pt",
              textAlign: "justify"
            }}
          >
            K: Inferences drawn from other personal information.
          </p>
        </td>
        <td
          style={{
            width: "171pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s9"
            style={{
              paddingTop: "6pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              textAlign: "left"
            }}
          >
            Registration and use of the App.
          </p>
        </td>
        <td
          style={{
            width: "162pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderRightStyle: "solid",
            borderRightWidth: "1pt"
          }}
        >
          <p
            className="s9"
            style={{
              paddingTop: "6pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              textAlign: "left"
            }}
          >
            None.
          </p>
        </td>
      </tr>
    </tbody>
  </table>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <p
    className="s8"
    style={{
      paddingTop: "4pt",
      paddingLeft: "161pt",
      textIndent: "0pt",
      textAlign: "center"
    }}
  >
    Your Rights and Choices
  </p>
  <p
    style={{
      paddingTop: "9pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "justify"
    }}
  >
    The CCPA provides California residents with specific rights regarding their
    personal information. This section describes your CCPA rights and explains
    how to exercise those rights.
  </p>
  <p
    className="s4"
    style={{
      paddingTop: "9pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "justify"
    }}
  >
    Right to Know and Data Portability
  </p>
  <p
    style={{
      paddingTop: "9pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "justify"
    }}
  >
    You have the right to request that we disclose certain information to you
    about our collection and use of your personal information over the past 12
    months (the “right to know”). Once we receive your request and confirm your
    identity, we will disclose to you:
  </p>
  <ul id="l14">
    <li data-list-text="●">
      <p
        style={{
          paddingTop: "11pt",
          paddingLeft: "47pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        The categories of personal information we collected about you.
      </p>
    </li>
    <li data-list-text="●">
      <p
        style={{
          paddingTop: "1pt",
          paddingLeft: "47pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        The categories of sources for the personal information we collected
        about you.
      </p>
    </li>
    <li data-list-text="●">
      <p
        style={{
          paddingTop: "1pt",
          paddingLeft: "47pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        Our business or commercial purpose for collecting or selling that
        personal information.
      </p>
    </li>
    <li data-list-text="●">
      <p
        style={{
          paddingTop: "1pt",
          paddingLeft: "47pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        The categories of third parties with whom we share that personal
        information.
      </p>
    </li>
    <li data-list-text="●">
      <p
        style={{
          paddingTop: "1pt",
          paddingLeft: "47pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        If we sold or disclosed your personal information for a business
        purpose, two separate lists disclosing:
      </p>
      <ul id="l15">
        <li data-list-text="●">
          <p
            style={{
              paddingTop: "1pt",
              paddingLeft: "65pt",
              textIndent: "-18pt",
              textAlign: "left"
            }}
          >
            sales, identifying the personal information categories that each
            category of recipient purchased; and
          </p>
        </li>
        <li data-list-text="●">
          <p
            style={{
              paddingTop: "1pt",
              paddingLeft: "65pt",
              textIndent: "-18pt",
              textAlign: "left"
            }}
          >
            disclosures for a business purpose, identifying the personal
            information categories that each category of recipient obtained.
          </p>
        </li>
      </ul>
    </li>
    <li data-list-text="●">
      <p
        style={{
          paddingTop: "5pt",
          paddingLeft: "47pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        The specific pieces of personal information we collected about you (also
        called a data portability request).
      </p>
    </li>
  </ul>
  <p
    style={{
      paddingTop: "6pt",
      paddingLeft: "14pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    We do not provide a right to know or data portability disclosure for B2B
    personal information.
  </p>
  <p
    className="s4"
    style={{
      paddingTop: "10pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    Right to Delete
  </p>
  <p
    style={{
      paddingTop: "9pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    You have the right to request that we delete any of your personal
    information that we collected from you and retained, subject to certain
    exceptions (the “right to delete”). Once we receive your request and confirm
    your identity, we will review your request to see if an exception allowing
    us to retain the information applies. We may deny your deletion request if
    retaining the information is necessary for us or our service provider(s) to:
  </p>
  <ol id="l16">
    <li data-list-text={1}>
      <p
        style={{
          paddingTop: "9pt",
          paddingLeft: "47pt",
          textIndent: "-21pt",
          textAlign: "left"
        }}
      >
        Complete the transaction for which we collected the personal
        information, provide a good or service that you requested, take actions
        reasonably anticipated within the context of our ongoing business
        relationship with you, fulfill the terms of a written warranty or
        product recall conducted in accordance with federal law, or otherwise
        perform our contract with you.
      </p>
    </li>
    <li data-list-text={2}>
      <p
        style={{ paddingLeft: "47pt", textIndent: "-21pt", textAlign: "left" }}
      >
        Detect security incidents, protect against malicious, deceptive,
        fraudulent, or illegal activity, or prosecute those responsible for such
        activities.
      </p>
    </li>
    <li data-list-text={3}>
      <p
        style={{
          paddingLeft: "47pt",
          textIndent: "-21pt",
          lineHeight: "14pt",
          textAlign: "left"
        }}
      >
        Debug products to identify and repair errors that impair existing
        intended functionality.
      </p>
    </li>
    <li data-list-text={4}>
      <p
        style={{ paddingLeft: "47pt", textIndent: "-21pt", textAlign: "left" }}
      >
        Exercise free speech, ensure the right of another consumer to exercise
        their free speech rights, or exercise another right provided for by law.
      </p>
    </li>
    <li data-list-text={5}>
      <p
        style={{ paddingLeft: "47pt", textIndent: "-21pt", textAlign: "left" }}
      >
        Comply with the <i>California Electronic Communications Privacy Act </i>
        (Cal. Penal Code § 1546 <i>et. seq.</i>).
      </p>
    </li>
    <li data-list-text={6}>
      <p
        style={{ paddingLeft: "47pt", textIndent: "-21pt", textAlign: "left" }}
      >
        Enable solely internal uses that are reasonably aligned with consumer
        expectations based on your relationship with us.
      </p>
    </li>
    <li data-list-text={7}>
      <p
        style={{
          paddingLeft: "47pt",
          textIndent: "-21pt",
          lineHeight: "14pt",
          textAlign: "left"
        }}
      >
        Comply with a legal obligation.
      </p>
    </li>
    <li data-list-text={8}>
      <p
        style={{ paddingLeft: "47pt", textIndent: "-21pt", textAlign: "left" }}
      >
        Make other internal and lawful uses of that information that are
        compatible with the context in which you provided it.
      </p>
    </li>
  </ol>
  <p
    style={{
      paddingTop: "5pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    We will delete or deidentify personal information not subject to one of
    these exceptions from our records and will direct our service providers to
    take similar action.
  </p>
  <p
    style={{
      paddingTop: "9pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    We do not provide these deletion rights for B2B personal information.
  </p>
  <p
    className="s4"
    style={{
      paddingTop: "10pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    Exercising Your Rights to Know or Delete
  </p>
  <p
    style={{
      paddingTop: "9pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    <a href="mailto:info@parlaye.com" className="s5" target="_blank">
      To exercise your rights to know or delete described above, please submit a
      request by emailing us at{" "}
    </a>
    <a href="mailto:info@parlaye.com" className="a" target="_blank">
      info@parlaye.com
    </a>
    <a href="mailto:info@parlaye.com" className="s5" target="_blank">
      .
    </a>
  </p>
  <p
    style={{
      paddingTop: "9pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    Only you, or someone legally authorized to act on your behalf, may make a
    request to know or delete related to your personal information.
  </p>
  <p
    style={{
      paddingTop: "9pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    You may also make a request to know or delete on behalf of your child by the
    same method.
  </p>
  <p
    style={{
      paddingTop: "9pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    You may only submit a request to know twice within a 12-month period. Your
    request to know or delete must:
  </p>
  <ul id="l17">
    <li data-list-text="●">
      <p
        style={{
          paddingTop: "5pt",
          paddingLeft: "47pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        Provide sufficient information that allows us to reasonably verify you
        are the person about whom we collected personal information or an
        authorized representative, which may include:
      </p>
      <ul id="l18">
        <li data-list-text="●">
          <p
            style={{
              paddingTop: "1pt",
              paddingLeft: "65pt",
              textIndent: "-18pt",
              textAlign: "left"
            }}
          >
            Two (2) pieces of government-issued photo from a state, provincial,
            or federal government.
          </p>
        </li>
        <li data-list-text="●">
          <p
            style={{
              paddingTop: "1pt",
              paddingLeft: "65pt",
              textIndent: "-18pt",
              textAlign: "left"
            }}
          >
            Parental or guardian identification information.
          </p>
        </li>
      </ul>
    </li>
    <li data-list-text="●">
      <p
        style={{
          paddingTop: "1pt",
          paddingLeft: "47pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        Describe your request with sufficient detail that allows us to properly
        understand, evaluate, and respond to it.
      </p>
      <p
        style={{
          paddingTop: "5pt",
          paddingLeft: "11pt",
          textIndent: "0pt",
          textAlign: "left"
        }}
      >
        We cannot respond to your request or provide you with personal
        information if we cannot verify your identity or authority to make the
        request and confirm the personal information relates to you.
      </p>
      <p
        style={{
          paddingTop: "9pt",
          paddingLeft: "11pt",
          textIndent: "0pt",
          textAlign: "left"
        }}
      >
        You do not need to create an account with us to submit a request to know
        or delete. However, we do consider requests made through your password
        protected account sufficiently verified when the request relates to
        personal information associated with that specific account.
      </p>
      <p
        style={{
          paddingTop: "9pt",
          paddingLeft: "11pt",
          textIndent: "0pt",
          textAlign: "left"
        }}
      >
        We will only use personal information provided in the request to verify
        the requestor's identity or authority to make it.
      </p>
      <p
        className="s4"
        style={{
          paddingTop: "9pt",
          paddingLeft: "11pt",
          textIndent: "0pt",
          textAlign: "left"
        }}
      >
        Response Timing and Format
      </p>
      <p
        style={{
          paddingTop: "9pt",
          paddingLeft: "11pt",
          textIndent: "0pt",
          textAlign: "left"
        }}
      >
        <a href="mailto:info@parlaye.com" className="s5" target="_blank">
          We will confirm receipt of your request within ten (10) business days.
          If you do not receive confirmation within the 10-day timeframe, please
          contact{" "}
        </a>
        <a href="mailto:info@parlaye.com" className="a" target="_blank">
          info@parlaye.com
        </a>
        <a href="mailto:info@parlaye.com" className="s5" target="_blank">
          .
        </a>
      </p>
      <p
        style={{
          paddingTop: "9pt",
          paddingLeft: "11pt",
          textIndent: "0pt",
          textAlign: "justify"
        }}
      >
        We endeavor to substantively respond to a verifiable consumer request
        within forty-five (45) days of its receipt. If we require more time (up
        to another 45 days), we will inform you of the reason and extension
        period in writing.
      </p>
      <p
        style={{
          paddingTop: "9pt",
          paddingLeft: "11pt",
          textIndent: "0pt",
          textAlign: "justify"
        }}
      >
        If you have an account with us, we will deliver our written response to
        that account. If you do not have an account with us, we will deliver our
        written response by mail or electronically, at your option.
      </p>
      <p
        style={{
          paddingTop: "9pt",
          paddingLeft: "11pt",
          textIndent: "0pt",
          textAlign: "left"
        }}
      >
        Any disclosures we provide will only cover the 12-month period preceding
        our receipt of your request. The response we provide will also explain
        the reasons we cannot comply with a request, if applicable. For data
        portability requests, we will select a format to provide your personal
        information that is readily usable and should allow you to transmit the
        information from one entity to another entity without hindrance.
      </p>
      <p
        style={{
          paddingTop: "10pt",
          paddingLeft: "11pt",
          textIndent: "0pt",
          textAlign: "left"
        }}
      >
        We do not charge a fee to process or respond to your verifiable consumer
        request unless it is excessive, repetitive, or manifestly unfounded. If
        we determine that the request warrants a fee, we will tell you why we
        made that decision and provide you with a cost estimate before
        completing your request.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        className="s8"
        style={{
          paddingTop: "4pt",
          paddingLeft: "161pt",
          textIndent: "0pt",
          textAlign: "center"
        }}
      >
        Non-Discrimination
      </p>
      <p
        style={{
          paddingTop: "9pt",
          paddingLeft: "11pt",
          textIndent: "0pt",
          textAlign: "left"
        }}
      >
        We will not discriminate against you for exercising any of your CCPA
        rights. Unless permitted by the CCPA, we will not:
      </p>
    </li>
    <li data-list-text="●">
      <p
        style={{
          paddingTop: "5pt",
          paddingLeft: "47pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        Deny you goods or services.
      </p>
    </li>
    <li data-list-text="●">
      <p
        style={{
          paddingTop: "1pt",
          paddingLeft: "47pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        Charge you different prices or rates for goods or services, including
        through granting discounts or other benefits, or imposing penalties.
      </p>
    </li>
    <li data-list-text="●">
      <p
        style={{
          paddingTop: "1pt",
          paddingLeft: "47pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        Provide you a different level or quality of goods or services.
      </p>
    </li>
    <li data-list-text="●">
      <p
        style={{
          paddingTop: "1pt",
          paddingLeft: "47pt",
          textIndent: "-18pt",
          textAlign: "left"
        }}
      >
        Suggest that you may receive a different price or rate for goods or
        services or a different level or quality of goods or services.
      </p>
    </li>
  </ul>
  <p
    className="s8"
    style={{
      paddingTop: "6pt",
      paddingLeft: "175pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    Changes to California Policy
  </p>
  <p
    style={{
      paddingTop: "9pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    We reserve the right to amend this California Policy at our discretion and
    at any time. When we make changes to this California Policy, we will post
    the updated notice on the App and update the notice's effective date. Your
    continued use of our App following the posting of changes constitutes your
    acceptance of such changes.
  </p>
  <p
    className="s8"
    style={{
      paddingTop: "9pt",
      paddingLeft: "161pt",
      textIndent: "0pt",
      textAlign: "center"
    }}
  >
    Contact Information
  </p>
  <p
    style={{
      paddingTop: "9pt",
      paddingLeft: "11pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    <a href="mailto:info@parlaye.com" className="s5" target="_blank">
      If you have any questions or comments about this notice, the ways in which
      the Company collects and uses your information described here, your
      choices and rights regarding such use, or wish to exercise your rights
      under California law, please do not hesitate to contact us at{" "}
    </a>
    <a href="mailto:info@parlaye.com" className="a" target="_blank">
      info@parlaye.com
    </a>
    <a href="mailto:info@parlaye.com" className="s5" target="_blank">
      .
    </a>
  </p>
</>

      </div>
    )
}

export default PrivacyPolicy;
